<template>
  <div class="view-home pb-5">
    <action-dispatcher
      class="position-relative"
      action="showcases/getShowcases"
    >
      <div class="px-4 px-lg-5 py-3">
        <swiper :slides-per-view="1" :navigation="true">
          <swiper-slide v-for="showcase in visibleShowcases" :key="showcase.id">
            <banner :showcase="showcase" />
          </swiper-slide>
        </swiper>
      </div>
    </action-dispatcher>

    <div class="position-relative py-4">
      <div class="px-4 px-lg-5">
        <swiper :navigation="true" :breakpoints="breakpoints">
          <swiper-slide v-for="item in menuItems" :key="item.key">
            <router-link
              class="btn btn-trail"
              :class="{ workout: item.highlight }"
              :to="item.to"
            >
              <img
                v-if="item.photo"
                :class="{ 'highlight-category-icon': item.highlight }"
                :src="item.photo"
              />
              <img v-else src="@/assets/images/icon-category.png" />
              <span>{{ item.name }}</span>
            </router-link>
          </swiper-slide>
        </swiper>
      </div>
    </div>

    <action-dispatcher action="students/getLastLessons" class="py-4">
      <template v-if="_lastLessons.length">
        <div class="px-4 px-lg-5">
          <h5 class="text-light">Continue de onde parou...</h5>
        </div>
        <div class="position-relative">
          <div class="px-4 px-lg-5">
            <swiper :navigation="true" :breakpoints="breakpoints">
              <swiper-slide v-for="progress in _lastLessons" :key="progress.id">
                <last-lesson-slide :progress="progress" />
              </swiper-slide>
            </swiper>
          </div>
        </div>
      </template>
    </action-dispatcher>

    <action-dispatcher action="courses/getHomeCategories">
      <template v-for="category in sortedHomeCategories">
        <div
          v-if="category.lessons.length"
          :key="category.slug"
          class="home-category py-4"
          :class="{ 'home-category--highlight': isHighlightCategory(category) }"
        >
          <div class="px-4 px-lg-5">
            <h5
              :class="{
                'home-category__highlight-title': isHighlightCategory(category)
              }"
            >
              {{ category.name }}
            </h5>
          </div>
          <div class="position-relative">
            <div class="px-4 px-lg-5">
              <swiper :navigation="true" :breakpoints="breakpoints">
                <swiper-slide
                  v-for="lesson in category.lessons"
                  :key="lesson.id"
                >
                  <lesson-slide :lesson="lesson" />
                </swiper-slide>
              </swiper>
            </div>
          </div>
        </div>
      </template>
    </action-dispatcher>
  </div>
</template>

<script>
import Banner from "@/components/home/Banner";
import Swiper from "@/components/Swiper";
import SwiperSlide from "@/components/SwiperSlide";
import LessonSlide from "@/components/home/LessonSlide";
// import PodcastSlide from "@/components/home/PodcastSlide";
import LastLessonSlide from "@/components/home/LastLessonSlide";
import { mapState } from "vuex";
import { breakpoints } from "@/functions/helpers.js";

const HIGHLIGHT_CATEGORY = "comece por aqui";
const normalizeCategoryName = category =>
  ((category && category.name) || "")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
const isHighlightCategory = category =>
  ((category && category.name) || "").trim().toLowerCase() ===
  HIGHLIGHT_CATEGORY;

export default {
  components: {
    Banner,
    Swiper,
    LessonSlide,
    SwiperSlide,
    // PodcastSlide,
    LastLessonSlide
  },
  data() {
    return {
      breakpoints,
      masterclassBreakpoints: {
        768: {
          slidesPerView: 2
        },
        992: {
          slidesPerView: 3
        },
        1200: {
          slidesPerView: 4
        },
        1600: {
          slidesPerView: 5
        }
      }
    };
  },
  computed: {
    ...mapState("courses", [
      "categories",
      "feed",
      "trails",
      "categoryLessons",
      "homeCategories"
    ]),
    ...mapState("showcases", ["showcases"]),
    ...mapState("user", ["user"]),
    // ...mapState("podcasts", ["podcasts"]),
    ...mapState("students", ["lastLessons"]),
    visibleShowcases() {
      return this.showcases.filter(showcase => {
        const metadata = [
          showcase.title,
          showcase.text,
          showcase.cover_app,
          showcase.cover_web,
          showcase.link
        ]
          .filter(Boolean)
          .join(" ");
        return !/carta/i.test(metadata);
      });
    },
    highlightCategory() {
      return this.categories.find(isHighlightCategory) || null;
    },
    menuItems() {
      const categoriesByName = this.categories.reduce((items, category) => {
        items[normalizeCategoryName(category)] = category;
        return items;
      }, {});
      const categoryItem = (names, highlight = false) => {
        const aliases = Array.isArray(names) ? names : [names];
        const category = aliases
          .map(name => categoriesByName[name])
          .find(Boolean);
        return category
          ? {
              key: `category-${category.id}`,
              name: category.name,
              photo: category.photo,
              highlight,
              to: { name: "trail", params: { ...category } }
            }
          : null;
      };

      return [
        categoryItem("comece por aqui", true),
        categoryItem("trabalhe"),
        categoryItem("sirva"),
        {
          key: "workout",
          name: "Seja Forte",
          photo: null,
          highlight: false,
          to: { name: "workout" }
        },
        categoryItem("nao encha o saco"),
        categoryItem(["aulas com italo marsili", "aulas com o italo"]),
        categoryItem("cartas"),
        {
          key: "love-guru",
          name: "Guru do Amor",
          photo: require("@/assets/images/love-guru/icon-category-red.png"),
          highlight: false,
          to: { name: "love-guru" }
        }
      ].filter(Boolean);
    },
    sortedHomeCategories() {
      const list = [...this.homeCategories];
      const index = list.findIndex(isHighlightCategory);
      if (index > 0) list.unshift(list.splice(index, 1)[0]);
      return list;
    },
    _lastLessons() {
      return this.lastLessons.filter(l => l.resource && l.lesson);
    },
    feedLessons() {
      return this.feed.reduce((prev, cur) => [...prev, ...cur.lessons], []);
    },
    notebooks() {
      return this.feedLessons.filter(lesson => !lesson.is_month);
    },
    masterclasses() {
      return this.feedLessons.filter(lesson => lesson.is_month);
    }
  },
  methods: {
    isHighlightCategory
  }
};
</script>

<style lang="scss" scoped>
.view-home {
  color: white;

  .btn-trail {
    background: linear-gradient(180deg, #262626 0%, #000000 100%);
    border-radius: 6px;
    font-weight: 500;
    font-size: 14px;
    color: white;
    border: none;
    width: 100%;
    padding: 24px;
    height: 130px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    transition: 0.2s opacity;

    &.workout {
      background: #ff622c;
    }

    .highlight-category-icon {
      filter: brightness(0) invert(1);
    }

    img {
      height: 24px;
      margin-bottom: 10px;
    }

    &:hover {
      opacity: 0.8;
    }
  }

  h5 {
    margin-bottom: 16px;
    font-size: 18px;
  }

  .home-category--highlight {
    background: linear-gradient(
      90deg,
      rgba(251, 38, 62, 0.14) 0%,
      rgba(251, 38, 62, 0.04) 60%,
      rgba(251, 38, 62, 0) 100%
    );
    border-left: 4px solid #fb263e;
  }

  .home-category__highlight-title {
    color: #fb263e;
    font-size: 24px;
    font-weight: 700;
  }

  @media (max-width: 767.98px) {
    .home-category--highlight {
      border-left-width: 3px;
    }

    .home-category__highlight-title {
      font-size: 20px;
    }
  }
}
</style>
